/**
 * Checks if a value is not empty.
 *
 * @param {any} value The value to check.
 * @returns {boolean} Whether the value is not empty.
 */
export const notEmpty = (value) => {
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    if (typeof value === "string") {
        return value.length > 0;
    }
    return !!value;
};
